export default __webpack_public_path__ + "static/media/ClientesIconFinish.1c758c37.svg";